// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
:host .header {
  background-color: #4474F5;
  display: flex;
  align-items: center;
  padding: 10px 0;
}
:host .header img {
  height: 85px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AACF;AAEE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AACI;EACE,YAAA;AACN","sourcesContent":[":host {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n\n\n  .header {\n    background-color: #4474F5;\n    display: flex;\n    align-items: center;\n    padding: 10px 0;\n    img {\n      height: 85px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
